import { FormType, DashboardRoutes, Locales } from "@simplyk/common";
import { stringify } from "query-string";

import { BadgeVibe } from "@/dashboard-design-system/Badge";

export const FRONTEND_URL = process.env.NEXT_PUBLIC_FRONTEND_URL as string;

export const getEditFormLink = ({
  formId,
  formType,
  params,
  tag,
}: {
  formId: string;
  formType: FormType;
  params?: Record<string, unknown>;
  tag?: string;
}): string => {
  const queryParams = params ? `?${stringify(params || {})}` : "";
  const tagParams = tag ? `#${tag}` : "";
  if (formType === FormType.Ticketing) {
    return `/o${DashboardRoutes.TicketingEdit.replace(":id", formId)}${queryParams}${tagParams}`;
  } else if (formType === FormType.DonationForm) {
    return `/o${DashboardRoutes.DonationFormsEdit.replace(":id", formId)}${queryParams}${tagParams}`;
  }
  return "";
};

export const LandingPageUrl =
  process.env.NODE_ENV === "production"
    ? {
        [Locales.EN]: "https://www.zeffy.com/",
        [Locales.ES]: "https://www.zeffy.com/",
        [Locales.FR]: "https://fr.zeffy.com/",
      }
    : {
        [Locales.EN]: process.env.NEXT_PUBLIC_FRONTEND_URL + "/login",
        [Locales.ES]: process.env.NEXT_PUBLIC_FRONTEND_URL + "/login",
        [Locales.FR]: process.env.NEXT_PUBLIC_FRONTEND_URL + "/login",
      };

export enum SubMenu {
  Fundraising = "fundraising",
  Crm = "crm",
  Bank = "bank",
  Referral = "referral",
}

export enum SubMenuItem {
  Campaigns = "fundraising.campaigns",
  Payments = "fundraising.payments",
  Insights = "fundraising.insights",
  Receipts = "fundraising.receipts",
  Contacts = "crm.contacts",
  Emails = "crm.emails",
  Bank = "bank.overview",
  Payouts = "bank.payouts",
  Transactions = "bank.transactions",
  Balance = "bank.balance",
  NewsletterForms = "crm.forms",
  PostMail = "crm.postMail",
  ContactLists = "crm.lists",
}

export interface MenuItem {
  name: SubMenu | SubMenuItem;
  isActive: boolean;
  iconSrc?: React.FC<React.SVGProps<SVGSVGElement>>;
  isOpen?: boolean;
  path: string;
  items?: MenuItem[];
  openInNewTab?: boolean;
  isFeatureActivated: boolean;
  isFeatureAllowed: boolean;
  displayNotificationDot?: boolean;
  notificationDotVibe?: BadgeVibe;
  label?: string;
}
